<div class="step-template">
  <h2>Step {{ step.stepIndex }}</h2>
  <div class="step-content-label">
    Here's where you show content for step {{ step.stepIndex }}

    <form [formGroup]="formGroup" class="cta">
      <div [hidden]="step.stepIndex != 1">
        <div class="row gtr-uniform gtr-50">
          <div class="col-8 col-12-xsmall">
            <input
              type="text"
              formControlName="name"
              id="name"
              placeholder="Name"
            />
          </div>
          <div class="col-8 col-12-xsmall">
            <input
              type="text"
              formControlName="dob"
              id="dob"
              placeholder="Date of Birth"
            />
          </div>
          <div class="col-8 col-12-xsmall">
            <input
              type="text"
              formControlName="address"
              id="address"
              placeholder="Address and Postcode"
            />
          </div>
          <div class="col-8 col-12-xsmall">
            <label class="form-container"
              >All Dates
              <input
                type="checkbox"
                formControlName="alldates"
                checked="checked"
              />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >Monday 16th
              <input type="checkbox" formControlName="monday16th" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >Tuesday 17th
              <input type="checkbox" formControlName="tuesday17th" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >Wednesday 18th
              <input type="checkbox" formControlName="wednesday18th" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >Thursday 19th
              <input type="checkbox" formControlName="thursday19th" />
              <span class="checkmark"></span>
            </label>
            <label class="form-container"
              >Friday 20th
              <input type="checkbox" formControlName="frisday20th" />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="col-8 col-12-xsmall">
            <input
              type="email"
              formControlName="email"
              id="email"
              placeholder="Your Email Address"
            />
          </div>
          <div class="col-4 col-12-xsmall">
            <input type="submit" value="Get Started" class="fit primary" />
          </div>
        </div>
      </div>

      <div [hidden]="step.stepIndex != 2">
        <div class="row gtr-uniform gtr-50">
          <div class="col-8 col-12-xsmall">
            <input
              type="text"
              formControlName="parentCarerName"
              id="parentCarerName"
              placeholder="Parent / Carer Name"
            />
          </div>
          <div class="col-8 col-12-xsmall">
            <input
              type="text"
              formControlName="relationshipToYP"
              id="relationshipToYP"
              placeholder="Relationshiip to tO Young Person"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
  <button class="step-complete-btn" (click)="onCompleteStep()">
    <span class="completed-step-check material-icons">
      {{ step.isComplete ? "check_circle" : "panorama_fish_eye" }} </span
    >Complete Step {{ step.stepIndex }}
  </button>
</div>
